export default "__VITE_ASSET__whIShVdJ__"